import * as type from './mutations-types'

export default {
    [type.GET_getAreaTree](state, data) {
        state.areatree = data;
    },
    [type.CLASSCODE](state, data) {
        state.classcode = data;
    },
    [type.GET_SUBMITHOSPITAL](state, data) {
        state.submitHospital = data;
    },
    [type.GET_AREAHOSPITAL](state, data) {
        state.areahospital = data;
    },
    [type.UPDATE_CREATEHOSINFO](state, data) {
        state.createHosInfo = data;
    }
}
